/**
 * errMsg — normalise a parsed error response into a safe display STRING.
 *
 * Backend errors raised via `sanitized_http_exception` return
 * `detail = { message, error_id }` (an OBJECT), while other endpoints return
 * `detail` as a plain string. Passing an object straight into `toast.error(...)`
 * makes React throw "Objects are not valid as a React child" and crashes the
 * whole app into the GlobalErrorBoundary. Always route error detail through this.
 */
export function errMsg(data, fallback = 'Something went wrong') {
  const d = data?.detail ?? data?.message ?? data;
  if (typeof d === 'string') return d;
  if (d && typeof d === 'object') return d.message || d.error || fallback;
  return fallback;
}

export default errMsg;
